export const BRAND_PRIMARY = '@brand-primary';
export const BRAND_BACKGROUND = '@brand-background';

export function resolveBrandColor(value, overlay) {
	if(value === BRAND_PRIMARY) return overlay?.primary_color || '#7c5cff';
	if(value === BRAND_BACKGROUND) return overlay?.background_color || '#000000';
	return value;
}

// Brand tokens ("@brand-primary") may sit anywhere inside a widget's settings.
export function resolveBrandDeep(value, overlay) {
	if(typeof value === 'string') return resolveBrandColor(value, overlay);
	if(Array.isArray(value)) return value.map(v => resolveBrandDeep(v, overlay));
	if(value && typeof value === 'object') return Object.fromEntries(Object.entries(value).map(([ k, v ]) => [ k, resolveBrandDeep(v, overlay) ]));
	return value;
}
